import { useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X, Phone, Heart, User, LogIn } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";
import { useFavorites } from "@/context/FavoritesContext";

const links = [
  { to: "/", label: "Accueil" },
  { to: "/vehicules", label: "Nos véhicules" },
  { to: "/vendre", label: "Vendre" },
  { to: "/recherche", label: "Recherche perso" },
  { to: "/importation", label: "Importation" },
  { to: "/atelier", label: "Atelier" },
  { to: "/application", label: "Application" },
  { to: "/contact", label: "Contact" },
];

export function Navbar() {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();
  const { user } = useAuth();
  const { count } = useFavorites();
  const authed = user && user !== false;

  return (
    <header
      data-testid="main-navbar"
      className="fixed top-0 inset-x-0 z-50 border-b border-white/10 bg-black/60 backdrop-blur-2xl"
    >
      <nav className="max-w-7xl mx-auto px-5 lg:px-8 h-16 flex items-center justify-between gap-4">
        <Link to="/" data-testid="nav-logo" className="flex items-center group">
          <img src="/logo.png" alt="AS AUTO Garage" className="h-14 w-auto object-contain" />
        </Link>

        <div className="hidden xl:flex items-center gap-1">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-link-${l.to === "/" ? "home" : l.to.slice(1)}`}
              className={({ isActive }) =>
                `px-3 py-2 text-sm font-medium rounded-sm transition-colors ${
                  isActive ? "text-[#C5A059]" : "text-neutral-300 hover:text-white"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </div>

        <div className="hidden xl:flex items-center gap-4">
          <Link to={authed ? "/compte" : "/connexion"} data-testid="nav-favorites" className="relative text-neutral-300 hover:text-white transition-colors" aria-label="Favoris">
            <Heart className="h-5 w-5" />
            {count > 0 && <span className="absolute -top-2 -right-2 h-4 min-w-4 px-1 rounded-full bg-[#C5A059] text-black text-[10px] font-bold flex items-center justify-center">{count}</span>}
          </Link>
          <a href="tel:0767876026" data-testid="nav-call-btn" className="flex items-center gap-2 text-sm text-neutral-300 hover:text-white transition-colors">
            <Phone className="h-4 w-4 text-[#C5A059]" /> 07 67 87 60 26
          </a>
          <Link to={authed ? "/compte" : "/connexion"} data-testid="nav-account">
            <Button size="sm" className="bg-[#C5A059] text-black hover:bg-[#E6C678] rounded-sm">
              {authed ? <><User className="h-4 w-4 mr-2" /> Mon compte</> : <><LogIn className="h-4 w-4 mr-2" /> Connexion</>}
            </Button>
          </Link>
        </div>

        <button
          data-testid="mobile-menu-toggle"
          className="xl:hidden text-white p-2"
          onClick={() => setOpen((v) => !v)}
          aria-label="Menu"
        >
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </nav>

      {open && (
        <div data-testid="mobile-menu" className="xl:hidden border-t border-white/10 bg-black/95 backdrop-blur-2xl">
          <div className="px-5 py-4 flex flex-col gap-1">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `px-3 py-3 text-base font-medium rounded-sm ${
                    isActive ? "text-[#C5A059] bg-white/5" : "text-neutral-200"
                  }`
                }
              >
                {l.label}
              </NavLink>
            ))}
            <a href="tel:0767876026" className="mt-2">
              <Button className="w-full bg-white/5 border border-white/15 text-white hover:bg-white/10 rounded-sm">
                <Phone className="h-4 w-4 mr-2" /> Appeler AS AUTO
              </Button>
            </a>
            <Link to={authed ? "/compte" : "/connexion"} onClick={() => setOpen(false)} className="mt-1">
              <Button className="w-full bg-[#C5A059] text-black hover:bg-[#E6C678] rounded-sm">
                {authed ? <><User className="h-4 w-4 mr-2" /> Mon compte</> : <><LogIn className="h-4 w-4 mr-2" /> Connexion / Inscription</>}
              </Button>
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
